import { render, staticRenderFns } from "./period-departments-table.vue?vue&type=template&id=882a74d4"
import script from "./period-departments-table.vue?vue&type=script&lang=js"
export * from "./period-departments-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports